import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mto_component_option_compatibility_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mto_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  component1 : fromDatatype.GuidDataFieldInterface;
  option_item_1_guid : fromDatatype.GuidDataFieldInterface;
  component2 : fromDatatype.GuidDataFieldInterface;
  option_item_2_guid : fromDatatype.GuidDataFieldInterface;
  compatible: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  hdr_guid : fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_mto_component_option_compatibility_line_RowClass implements bl_fi_mto_component_option_compatibility_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mto_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  component1 : fromDatatype.GuidDataFieldInterface;
  option_item_1_guid : fromDatatype.GuidDataFieldInterface;
  component2 : fromDatatype.GuidDataFieldInterface;
  option_item_2_guid : fromDatatype.GuidDataFieldInterface;
  compatible: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  hdr_guid : fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
}
